import React from 'react';
import { Toaster } from "./portugal/ui/toaster";
import { Toaster as Sonner } from "./portugal/ui/sonner";
import { TooltipProvider } from "./portugal/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PortugalIndex from "../pages/portugal/Index";
import "../styles/portugal.css";

const queryClient = new QueryClient();

const Portugal = () => {
  return (
    <div className="portugal-container">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <PortugalIndex />
        </TooltipProvider>
      </QueryClientProvider>
    </div>
  );
};

export default Portugal;
